import { cn } from "@/lib/utils";

interface ToolbarProps {
  children: React.ReactNode;
  color?: string;
  large?: boolean;
  noPadding?: boolean;
}
const Toolbar = ({
  children,
  color = "bg-toolbar",
  large,
  noPadding,
}: ToolbarProps) => (
  <article
    className={cn(
      "flex flex-row justify-center w-full py-2 touch-device:py-4",
      large ? "h-30" : "h-15",
      color,
      noPadding && "justify-start",
    )}
  >
    <div
      className={cn(
        "flex flex-row w-full max-w-content items-center",
        !noPadding && "px-4 large:px-16 touch-device:px-4",
      )}
    >
      {children}
    </div>
  </article>
);

export default Toolbar;
